module.exports = __webpack_public_path__ + "static/media/Badge_SvgExpertCategoriel_PlaiesCicatrisation.b4aa05ae.png";